import { lockBodyScroll, unlockBodyScroll } from './bodyScrollLock'

/** 全屏灰色遮罩弹窗根节点（与 main.css 中 .hm-popup-mask / .modal-overlay 对齐） */
export const HM_OVERLAY_SELECTOR = [
  '.modal-overlay',
  '.cod-overlay-root',
  '.note-modal-root',
  '.cancel-schedule-modal-root',
  '.hm-modal-root',
  '.set-value-modal-overlay',
  '.cod-note-root',
  '.schedule-outer--embedded',
].join(',')

let trackedOverlayCount = 0
let observer: MutationObserver | null = null

function countOpenOverlays(): number {
  return document.querySelectorAll(HM_OVERLAY_SELECTOR).length
}

function syncScrollLock(): void {
  const openCount = countOpenOverlays()
  if (openCount > trackedOverlayCount) {
    for (let i = 0; i < openCount - trackedOverlayCount; i++) lockBodyScroll()
  } else if (openCount < trackedOverlayCount) {
    for (let i = 0; i < trackedOverlayCount - openCount; i++) unlockBodyScroll()
  }
  trackedOverlayCount = openCount
}

export function initOverlayScrollLock(): void {
  if (typeof document === 'undefined' || observer) return

  syncScrollLock()

  observer = new MutationObserver(syncScrollLock)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  })
}
